import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

const SortableSectionItem = ({ id, children }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  // Patch listeners to skip interactive elements
  const patchedListeners = {
    ...listeners,
    onPointerDown: (e) => {
      if (
        e.target.tagName === "INPUT" ||
        e.target.tagName === "BUTTON" ||
        e.target.tagName === "SELECT" ||
        e.target.tagName === "TEXTAREA" ||
        e.target.closest(".no-drag")
      ) {
        return;
      }
      listeners.onPointerDown?.(e);
    }
  };

  return (
    <div
      ref={setNodeRef}
      className="sortable-section-item"
      style={style}
      {...attributes}
    >
      {children({ handleListeners: patchedListeners })}
    </div>
  );
};

export default SortableSectionItem;
